export default "__VITE_ASSET__cKvMD1YJ__"